<template>
  <div class="section__list">
    <component :is="getComponent(section.flexLayout)" :content="section" v-for="section in sections"
               :key="section.flexKey"/>
  </div>
</template>

<script>
import {
  AvailablePositionsSection,
  BannerSection,
  BusinessUnitsSection,
  ContentCardsSection,
  CTAsSection,
  EmployeeSlidesSection,
  EmployeeTimelineSection,
  FaqSection,
  IconTextBlocksSection,
  SmallContentCardsSection
} from '@/components/sections/repeatables'

export default {
  name: 'SectionsRenderer',
  props: {
    sections: {
      type: Array,
      required: true
    }
  },
  methods: {
    getComponent(layoutKey) {
      switch (layoutKey) {
        case 'available-positions-section':
          return AvailablePositionsSection
        case 'banner-section':
          return BannerSection
        case 'business-units-section':
          return BusinessUnitsSection
        case 'content-cards-section':
          return ContentCardsSection
        case 'ctas-section':
          return CTAsSection
        case 'employee-slides-section':
          return EmployeeSlidesSection
        case 'employee-timeline-section':
          return EmployeeTimelineSection
        case 'faq-section':
          return FaqSection
        case 'icon-text-blocks-section':
          return IconTextBlocksSection
        case 'small-content-cards-section':
          return SmallContentCardsSection
        default:
          return null
      }
    }
  }
}
</script>